import React from "react";
import { CANDIDATE_VIEWS } from "./constants";

const TABS = [
  { value: CANDIDATE_VIEWS.CANDIDATE, label: "Candidate-wise", hint: "One row per candidate." },
  { value: CANDIDATE_VIEWS.ACTIVITY, label: "Activity-wise", hint: "One row per candidate stage. Refreshes every 15 seconds." },
];

const CandidateViewTabs = ({ value, onChange }) => {
  const active = TABS.find((t) => t.value === value) || TABS[0];
  return (
    <div className="candidate-view-tabs-bar">
      <div className="candidate-view-tabs" role="tablist">
        {TABS.map((tab) => (
          <button
            key={tab.value}
            type="button"
            role="tab"
            aria-selected={tab.value === value}
            className={`candidate-view-tab${tab.value === value ? " active" : ""}`}
            onClick={() => tab.value !== value && onChange(tab.value)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <span className="candidate-view-hint">{active.hint}</span>
    </div>
  );
};

export default CandidateViewTabs;
